import React from 'react';

/**
 * Erklärt, wann eine Änderung wo ankommt.
 *
 * Stand hier bis zum 31.08.2026 eine Schaltfläche „Für Suchmaschinen
 * aktualisieren". Sie setzte einen Bau-Webhook voraus, den Coolify erst ab v4
 * anbietet — auf diesem Server läuft v3.12, und die einzige Deploy-Route dort
 * verlangt ein Sitzungstoken der Oberfläche. Die Schaltfläche hätte also auf
 * absehbare Zeit nie etwas getan, und eine Schaltfläche, die nichts tut,
 * beschädigt das Vertrauen in alle anderen.
 *
 * Das Problem dahinter bleibt und wird jetzt anders gelöst: Ein nächtlicher
 * Bau um vier Uhr erneuert vorgerendertes HTML und Sitemap von selbst
 * (.github/workflows/nightly-rebuild.yml). Deshalb steht hier eine Auskunft
 * und keine Aufforderung: Es gibt nichts zu tun.
 */
const SuchmaschinenHinweis: React.FC<{ className?: string }> = ({ className }) => (
  <p className={className} style={{ margin: 0, fontSize: 13, lineHeight: 1.5, opacity: 0.75 }}>
    Änderungen sind <strong>sofort auf der Website sichtbar</strong>. Für
    Suchmaschinen und die Vorschau in WhatsApp und Facebook werden sie in der
    folgenden Nacht übernommen.
  </p>
);

export default SuchmaschinenHinweis;
